module.exports = __webpack_public_path__ + "img/google-icon.98b4956b.svg";